import Joi from "joi";
import { emailRegex } from "../../utils/common";
export const RegistrationSchema = Joi.object({
    first_name: Joi.string().min(3).max(50).required()
        .messages({
            "any.required": "First name is required.",
            "string.empty": "First name is required.",
            "string.min": "First name must be at least 3 characters.",
            "string.max": "First name must not exceed 255 characters.",
        }),
    last_name: Joi.string().min(2).max(50).required().messages({
        "any.required": "Last name is required.",
        "string.empty": "Last name is required.",
        "string.min": "Last name must be at least 3 characters.",
        "string.max": "Last name must not exceed 255 characters.",
    }),
    email: Joi.string().pattern(emailRegex).email({ tlds: { allow: false } }).required().messages({
        "string.pattern.base": "Invalid  email format",
        "string.base": "Email is required.",
        "string.required": "Email is required.",
        "string.invalid": "Email is required.",
        "string.empty": "Email is required.",
        "string.email": "Please provide a valid email address.",
    }),
    // password: Joi.string().min(6).max(255).optional(),
    password: Joi.string()
        .min(8)
        .max(255)
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!]).*$/, 'password requirements')
        .optional()
        .messages({
            'string.pattern.name': 'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.',
        }),
    phone: Joi.number()
        .integer()
        .required()
        .custom((value, helpers) => {
            if (!/^[6-9][0-9]{9}$/.test(value.toString())) {
                return helpers.error('any.invalid');
            }
            return value;
        }).messages({
            "number.pattern.base": "Invalid phone number format",
            "number.empty": "Phone no is required",
            "number.base": "Phone no is required",
            "any.empty": "Phone no is required",
            "any.required": "Phone no is required",
            "any.invalid": "Invalid phone number format."
        }),
    user_type: Joi.string()
        .valid('admin', 'agent', 'organization_admin', 'employee', 'single')
        .required()
        .messages({
            "any.required": "User type is required",
            "string.empty": "User type is required",
        }),
});